import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { Rate } from 'antd';
import { useWindowSize } from 'react-use';
import dayjs from 'dayjs';
import { imgUrl } from '@/shared/utils';

const CustomersTalkUsContent = ({ content }: { content: any }) => {
  const { width } = useWindowSize();

  const getPaddingLeft = useMemo(() => {
    if (width <= 1200) return 0;
    return (width - 1200) / 2;
  }, [width]);

  const getContent = useMemo(() => {
    const tempModel = content;

    return tempModel ? (
      <div className={styles.content}>
        {tempModel?.title && <h2>{tempModel?.title}</h2>}
        {tempModel?.desc && <p className={styles.titleDesc}>{tempModel?.desc}</p>}
        <div
          className={styles.container}
          style={{
            paddingLeft: `${getPaddingLeft}px`,
            paddingRight: `${getPaddingLeft}px`,
            marginLeft: `-${getPaddingLeft}px`,
            marginRight: `-${getPaddingLeft}px`,
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          {tempModel?.cards?.map((item: any, index: any) => {
            return (
              <div className={styles.cardContainer} key={index}>
                <div className={styles.userContainer}>
                  <Image
                    src={item?.imgPath ? imgUrl(item?.imgPath, 'small') : ''}
                    alt={item?.title}
                    className={styles.icon}
                    width={46}
                    height={46}
                    loading="lazy"
                  />
                  <span className={styles.userName}>{item?.title}</span>
                </div>

                <div className={styles.line} />

                <ul className={styles.starContainer}>
                  <Rate className={styles.star} allowHalf disabled value={Number(item?.points)} />
                  <span className={styles.date}>{dayjs(item?.date).format('MMM DD, YYYY')}</span>
                </ul>
                <h3 className={styles.desc}>{item?.desc}</h3>
              </div>
            );
          })}
        </div>
      </div>
    ) : null;
  }, [content, getPaddingLeft]);

  if (!content?.title) {
    return null;
  }

  return <>{getContent}</>;
};

export default CustomersTalkUsContent;
